import actions from 'src/modules/data/importer/dataImporterActions';
import importerReducers from 'src/modules/shared/importer/importerReducers';

export default importerReducers(actions);
